var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('work-order-view-formulation-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }